import React from 'react';

import promoIcon from '../static/img/promotion-icon.png'; 

import { useTranslation } from 'react-i18next';
 

function Promotion() {
  const { t } = useTranslation();
  return (
    <>
      <div className="box-navigation boxNav-promo">
        <div className="text">
          <h4>{t('Promotions')}</h4>
          <p>{t('Discover_all_our_offers')}</p>
        </div>
        <img src="/assets/img/promotion-icon.png" alt="Promotion Icon" />
      </div>
    </> 
  );
}

export default Promotion;
